import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import NSWRFSBadge from "../components/images/nswrfsBadge"
import { Card, CardBody } from "reactstrap"
import FadeIn from "react-fade-in"
import "./index.css"
import "bootstrap/dist/css/bootstrap.min.css"

export default function Index() {
  return (
    <Layout>
      <SEO title="Home" description="Marsden Park RFS Home Page" />
      <FadeIn>
        <Card outline color="white">
          <CardBody>
            <center>
              <div
                style={{
                  maxWidth: "317px",
                  maxHeight: "500px",
                }}
              >
                <NSWRFSBadge />
              </div>
              <div className="rfs-title">Marsden Park Rural Fire Service</div>
              <div className="pt-4">
                <div className="pledge">Dedicated to Community</div>
                <div className="pledge">Driven by Service</div>
                <div className="pledge">Directed by Experience</div>
              </div>
            </center>
          </CardBody>
        </Card>
      </FadeIn>
    </Layout>
  )
}
